import { getItemSubGroup } from "@workspace/api-zod/work-type";
import { getItemStage } from "./section-placement";

export interface QuotePlacementItem {
  category: string;
  trade?: string;
  name?: string;
  displayStage?: string | null;
  displaySubGroup?: string | null;
}

export type QuotePlacementTarget = {
  stage: string;
  subGroup?: string | null;
  targetIndex?: number;
  position?: "before" | "after";
};

export function getEffectiveQuoteStage(item: QuotePlacementItem): string {
  return item.displayStage || getItemStage(item.category, item.trade, item.name);
}

export function getEffectiveQuoteSubGroup(item: QuotePlacementItem): string | null {
  if (item.displaySubGroup !== undefined && item.displaySubGroup !== null) return item.displaySubGroup || null;
  return getItemSubGroup(item.category, item.name || "");
}

export function moveQuoteItem<T extends QuotePlacementItem>(
  items: T[],
  sourceIndex: number,
  target: QuotePlacementTarget,
): T[] {
  if (sourceIndex < 0 || sourceIndex >= items.length) return items;
  if (target.targetIndex === sourceIndex) return items;
  const next = [...items];
  const [source] = next.splice(sourceIndex, 1);
  const moved = {
    ...source,
    displayStage: target.stage,
    displaySubGroup: target.subGroup ?? "",
  };
  let insertionIndex = next.length;
  if (target.targetIndex !== undefined) {
    insertionIndex = target.targetIndex - (sourceIndex < target.targetIndex ? 1 : 0);
    if (target.position === "after") insertionIndex += 1;
    insertionIndex = Math.max(0, Math.min(insertionIndex, next.length));
  } else {
    const lastDestinationIndex = next.reduce((last, item, index) => (
      getEffectiveQuoteStage(item) === target.stage
      && getEffectiveQuoteSubGroup(item) === (target.subGroup ?? null)
        ? index
        : last
    ), -1);
    if (lastDestinationIndex >= 0) insertionIndex = lastDestinationIndex + 1;
  }
  next.splice(insertionIndex, 0, moved);
  return next;
}